import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './PostImages.css';
import ImageViewer from './ImageViewer';

const PostImages = ({ images = [], maxDisplay = 4, isModule = false }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  
  if (!images || images.length === 0) {
    return null;
  }

  // Sort images by sort_order
  const sortedImages = [...images].sort((a, b) => a.sort_order - b.sort_order);
  
  // If this is being used as a module in the grid and there's only one image,
  // return a module-like structure
  if (isModule && sortedImages.length === 1) {
    return (
      <>
        <div className="post-image-module">
          <div 
            className="post-card-module-image"
            onClick={() => {
              setSelectedImageIndex(0);
              setIsViewerOpen(true);
            }}
          >
            <img
              src={sortedImages[0].image_url}
              alt="Post image"
              className="post-card-module-image-img"
              loading="lazy"
            />
          </div>
        </div>

        {/* Image Viewer Modal - Rendered via Portal */}
        {mounted && createPortal(
          <ImageViewer
            images={sortedImages}
            initialIndex={0}
            isOpen={isViewerOpen}
            onClose={() => setIsViewerOpen(false)}
          />,
          document.body
        )}
      </>
    );
  }
  
  // For multiple images or when not used as a module, use the existing horizontal scrolling layout
  const displayImages = sortedImages;
  
  const handleImageClick = (image, index) => {
    setSelectedImageIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    console.log('closeViewer called!');
    setIsViewerOpen(false);
  };

  return (
    <>
      <div className="post-images-container">
        <div className="post-images-grid post-images-single-row">
          {displayImages.map((image, index) => (
            <div 
              key={image.id} 
              className="post-image-item"
              onClick={() => handleImageClick(image, index)}
            >
              <img
                src={image.image_url}
                alt={`Post image ${index + 1}`}
                className="post-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Image Viewer Modal - Rendered via Portal */}
      {mounted && createPortal(
        <ImageViewer
          images={displayImages}
          initialIndex={selectedImageIndex}
          isOpen={isViewerOpen}
          onClose={closeViewer}
        />,
        document.body
      )}
    </>
  );
};

export default PostImages;
